import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { buildReportAbuseUrl } from './buildReportAbuseUrl.ts';

const REPORT_ABUSE_ATI_PREFIX = 'ati:cloud:confluence';
const REPORT_ABUSE_ARI_PREFIX = 'ari:cloud:confluence::content';

export type UseReportAbuseUrlOptions = {
	/** The content ID (e.g. Confluence page/blog/whiteboard ID) */
	contentId?: string | null;
	/** The Confluence content type, e.g. "page", "blogpost", "whiteboard" */
	contentType?: string | null;
};

/**
 * Returns the fully-qualified report-abuse URL. When the
 * cc_golden_path_report_abuse_extension gate is enabled, the URL is
 * pre-filled with additional context params (ati, ari, fileUrl,
 * reporteraaid). Otherwise only the bare base URL is returned.
 */
export const useReportAbuseUrl = ({ contentId, contentType }: UseReportAbuseUrlOptions): string => {
	const { cloudId, userId } = useSessionData();

	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (!fg('cc_golden_path_report_abuse_extension')) {
		return buildReportAbuseUrl({});
	}

	const ati = contentType ? `${REPORT_ABUSE_ATI_PREFIX}:${contentType}` : undefined;
	const ari = cloudId && contentId ? `${REPORT_ABUSE_ARI_PREFIX}/${contentId}` : undefined;
	const fileUrl = typeof window.location !== 'undefined' ? window.location.href : undefined;

	return buildReportAbuseUrl({ ati, ari, fileUrl, reporteraaid: userId });
};
